import { UTA_FORM_TA_FIELD_ENUM } from '@components-member/TradingAccounts/AccountCreate/enums';
import { IFormField } from '@components-shared/forms/formField.interface';
import { keyMap } from '@locales/lokalise/keyMap';
import { ENUM_CONSTANTS } from 'components/shared/enum.constants';

export const LEVERAGE_FIELD: IFormField = {
  name: UTA_FORM_TA_FIELD_ENUM.leverage,
  title: keyMap.commonLeverage,
  type: 'customSelect',
  options: [],
  required: true,
};

export const COPYTYPE_FIELD: IFormField = {
  name: UTA_FORM_TA_FIELD_ENUM.copyType,
  title: keyMap.tradingAccountsCopyType,
  type: 'customSelect',
  options: ENUM_CONSTANTS.ALLOCATION_METHOD,
  required: true,
  tooltip: keyMap.copyTradeAllocationModeDeterminesHowFollowersReplicate,
};

export const IBCODE_FIELD = {
  name: UTA_FORM_TA_FIELD_ENUM.ibCode,
  title: keyMap.sharedFieldsIbCode,
  attributes: { autoComplete: 'off' },
  tooltip: '',
};
